<template>
  <base-widget
    title="Information"
    class="client-information editable-background"
    @mouseenter.native="onMouseEnter"
    @mouseleave.native="onMouseLeave"
  >
    <div class="row">
      <div class="col-3 d-flex">
        <base-text class="info text-nowrap label mr-1">
          BIRTHDAY
        </base-text>
        <div class="d-flex input-text">
          <base-texteditable
            v-if="editable"
            ref="monthSelector"
            v-model="bdate_month"
            :placeholder="`${bdate_month ? bdate_month:'MM'}`"
            max-width="25px"
            @complete="editInformation"
          />
          <span v-if="editable">/</span>
          <base-texteditable
            v-if="editable"
            v-model="bdate_day"
            :placeholder="`${bdate_day ? bdate_day:'DD'}`"
            max-width="23px"
            @complete="editInformation"
          />
          <span v-if="editable">/</span>
          <base-texteditable
            v-if="editable"
            v-model="bdate_year"
            :placeholder="`${bdate_year ? bdate_year:'YYYY'}`"
            max-width="50px"
            @complete="editInformation"
          />
          <span
            v-else
            class="ml-3"
          >
            <template v-if="birth_date">
              {{ birth_date | nicedate('small') }}
            </template>
            <template v-else>
              &nbsp;&nbsp;&nbsp;- - -&nbsp;&nbsp;&nbsp;
            </template>
          </span>
        </div>
      </div>
      <div class="col-3 d-flex">
        <base-text class="info text-nowrap label">
          PHONE
        </base-text>
        <base-texteditable
          v-if="editable"
          v-model="phone"
          :placeholder="`${phone ? phone : 'Add Phone'}`"
          max-width="120px"
          class="pl-2 input-text"
          @complete="editInformation"
        />
        <base-text
          v-else
          class="ml-3 info input-text"
        >
          {{ phone ? phone : '&nbsp;&nbsp;&nbsp;- - -&nbsp;&nbsp;&nbsp;' }}
        </base-text>
      </div>
      <div class="col-3 d-flex">
        <base-text class="info text-nowrap label">
          BASED
        </base-text>
        <base-texteditable
          v-if="editable"
          v-model="based"
          :placeholder="`${based ? based : 'Add Location'}`"
          max-width="100px"
          class="pl-2 input-text"
          @complete="editInformation"
        />
        <base-text
          v-else
          class="ml-3 info input-text"
        >
          {{ based ? based : '&nbsp;&nbsp;&nbsp;- - -&nbsp;&nbsp;&nbsp;' }}
        </base-text>
      </div>
      <div class="col-3 d-flex">
        <base-text class="info text-nowrap label">
          LAST_VISIT
        </base-text>
        <base-text class="ml-3 info input-text">
          {{ last_visit ? last_visit : '&nbsp;&nbsp;&nbsp;- - -&nbsp;&nbsp;&nbsp;' }}
        </base-text>
      </div>
    </div>
    <div
      class="d-flex justify-content-end"
      style="position: absolute; bottom: 1rem; right: 1rem;"
    >
      <span v-if="isHover && !editable">
        <base-icon
          icon="pencil"
          @click="editModeOn()"
        />
      </span>
      <span
        v-if="editable"
        class="d-flex"
      >
        <base-text
          size="s"
          class="mr-4 cursor-pointer"
          @click.native="cancelEdit"
        >cancel</base-text>
        <base-text
          size="s"
          class="cursor-pointer"
          @click.native="editInformation"
        >save</base-text>
      </span>
    </div>
  </base-widget>
</template>
<script>
import hoverable from '@/components/mixins/hoverable';

export default {
  name: 'ClientInformation',
  mixins: [hoverable],
  props: {
    entries: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editable: false,
      birth_date: null,
      phone: null,
      based: null,
      bdate_day: null,
      bdate_month: null,
      bdate_year: null,
    };
  },
  computed: {
    last_visit() {
      if (!this.entries.last_visit) {
        return null;
      }
      return this.$options.filters.nicedate(this.entries.last_visit);
    },
  },
  watch: {
    entries(newVal) {
      this.setBirthdateInputs(newVal.birthday);
      this.phone = newVal.phone;
      this.based = newVal.based;
      this.birth_date = newVal.birthday;
    },
  },
  methods: {
    buildBirthDateFromInputs() {
      if ([this.bdate_year, this.bdate_month, this.bdate_day].every(((value) => value === ''))) return null;
      if (!this.bdate_year || !this.bdate_month || !this.bdate_day) return undefined;
      const newDate = new Date(this.bdate_year, this.bdate_month - 1, this.bdate_day);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(newDate.getTime())) return undefined;
      return newDate;
    },
    setBirthdateInputs(dateString) {
      if (!dateString || !dateString.length) {
        this.bdate_day = null;
        this.bdate_month = null;
        this.bdate_year = null;
        return;
      }
      const dateObj = new Date(dateString);
      this.bdate_day = dateObj.getDate().toString();
      this.bdate_month = (dateObj.getMonth() + 1).toString();
      this.bdate_year = dateObj.getFullYear().toString();
    },
    editInformation() {
      const payload = {
        pk: this.$route.params.id,
        phone_number: this.phone,
        location: this.based,
        birth_date: this.buildBirthDateFromInputs(),
      };
      this.$emit('updateCustomerInfo', payload);
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('User_Updated', {
          account_id: this.$store.state.account.user.user.email,
          lphone_number: this.phone,
          location: this.based,
          birth_date: this.buildBirthDateFromInputs(),
        });
      }
      this.editable = false;
    },
    cancelEdit() {
      this.setBirthdateInputs(this.entries.birthday);
      this.phone = this.entries.phone;
      this.based = this.entries.based;
      this.editable = false;
    },
    editModeOn() {
      this.editable = true;
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('user_updated', {
          account_id: this.$store.state.account.user.user.email,
        });
      }
      this.$nextTick().then(() => {
        this.$refs.monthSelector.focus();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  color: #AAAAAA;
  font-size: 11px;
}

.info {
  line-height: 15px;
  letter-spacing: 0.105px;
}

.input-text {
  font-size: 12px;
}

.client-information {
  position: relative;
}

.editable-background{
  &::v-deep .basecard {
    &:hover {
      background: $gray-light;
    }
  }
}
</style>
